import { useStore } from '@/store'
import WorldView    from '@/views/WorldView'
import HexView      from '@/views/HexView'
import DeepDiveView from '@/views/DeepDiveView'
import IncidentsView from '@/views/IncidentsView'
import FleetView    from '@/views/FleetView'
import { isStubView } from './stubPages'

export default function VizPanel() {
  const view = useStore(s => s.view)
  if (view === 'hex')       return <HexView />
  if (view === 'deep')      return <DeepDiveView />
  if (view === 'incidents') return <IncidentsView />
  if (view === 'fleet')     return <FleetView />
  if (isStubView(view))     return null
  return <WorldView />
}